import PropTypes from 'prop-types';
import ItemCard from '../ItemCard';
import GoFetch from '~/js/modules/fetchling';

const fetch = new GoFetch();

export default class CategoryItem extends React.Component {
  static propTypes = {
    categoryName: PropTypes.string,
    categoryId: PropTypes.number,
    categoryItems: PropTypes.array,
    inspirationId: PropTypes.number,
    initialRows: PropTypes.string,
    isMobile: PropTypes.bool,
    countries: PropTypes.array,
    modalUpdateHandler: PropTypes.func,
    isSuccessAddedHandler: PropTypes.func,
    getViewMoreRequestBody: PropTypes.func,
    userId: PropTypes.number,
    inspirationEvents: PropTypes.array,
    isReceptionItems: PropTypes.bool,
  };
  static defaultProps = {
    categoryName: '',
    categoryId: null,
    inspirationId: null,
    initialRows: '',
    isMobile: false,
    countries: [],
    categoryItems: [],
    modalUpdateHandler: () => null,
    isSuccessAddedHandler: () => null,
    getViewMoreRequestBody: () => null,
    userId: null,
    inspirationEvents: [],
    isReceptionItems: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      showSubcategories: false,
      isViewMoreActive: false,
      countries: [],
      allItems: [],
      fetchItems: [],
      isInitialFetch: false
    };
  }
  componentDidMount() {
    const { categoryItems } = this.props;

    if(categoryItems.length < 4 && categoryItems[0].viewMore) {
      this.setState({isInitialFetch: true});
      this._fetchCategoryItems(false);
    }
  }

  _filterItemsByRows = (itemsToRender) => {
    const rowsToShow = this.state.displayedRows ? this.state.displayedRows : this.props.initialRows;

    return (rowsToShow === 'ALL') ? itemsToRender.length : rowsToShow * 4;
  };

  _renderItems = (categoryItems, itemsPerRow) => {
    return categoryItems
      .slice(0, itemsPerRow)
      .map((item, index) => <ItemCard key={ index } itemData = { item } categoryId={this.props.categoryId} modalUpdateHandler={this.props.modalUpdateHandler} userId={this.props.userId} isSuccessAddedHandler={this.props.isSuccessAddedHandler} isGrid /> );
  };
  _viewMoreHandler = () => {
    const { categoryItems } = this.props;
    const currentItemsLength = categoryItems.length;

    if (!categoryItems[0].viewMore) {
      const newRows = Math.ceil(currentItemsLength / 4);

      this.setState({ displayedRows: newRows, isViewMoreActive: true});
    } else if (this.state.fetchItems.length === 0) {
      _.loaderHelper();
      this._fetchCategoryItems();
    } else {
      this.setState({allItems: this.state.fetchItems, displayedRows: this.state.fetchRows, isViewMoreActive: true});
    }
  };
  _fetchCategoryItems = (isViewMoreActive = true) => {
    const { categoryItems } = this.props;
    const requestBody = {
      categoryId: `${categoryItems[0].categoryId}`,
      event: `${categoryItems[0].event}`,
      viewMore: `${categoryItems[0].viewMore}`,
      inspirationId: `${this.props.inspirationId}`
    };

    this.props.getViewMoreRequestBody(requestBody);
    fetch.post('/weddings/get-category-items/', null, requestBody)
      .then((resp) => {
        const { data = {} } = resp;
        const { categoryItems: items = [] } = data;
        const thisInspirationItems = [];
        const otherInspirationItems = [];

        items.map(item => {
          if (item.inspirationName === categoryItems[0].inspirationName) {
            thisInspirationItems.push(item);
          } else {
            otherInspirationItems.push(item);
          }
        });
        const mergedItems = [...thisInspirationItems, ...otherInspirationItems];
        const displayedRows = this.state.isInitialFetch ? categoryItems[0].displayedRows : Math.ceil(mergedItems.length / 4);
        const fetchRows = Math.ceil(mergedItems.length / 4);
        const isInitialFetchShouldViewLess = this.state.isInitialFetch ? true : false;

        this.setState({ fetchItems: mergedItems, allItems: mergedItems, displayedRows, fetchRows, isViewMoreActive, isInitialFetch: false, isInitialFetchShouldViewLess});
      })
      .then( () => _.loaderHelper(false))
      .catch((err) => console.warn(err));
  };
  _viewLessHandler = () => {
    const { categoryItems } = this.props;
    const categoryContainer = document.querySelector(`.category-container.cat-id-${categoryItems[0].categoryId}`);
    const allItems = this.state.isInitialFetchShouldViewLess ? this.state.fetchItems : '';

    categoryContainer.scrollIntoView();
    this.setState({ allItems, displayedRows: categoryItems[0].displayedRows, isViewMoreActive: false });
  };
  _getSubCategories = (currentEventInfo) => {
    return currentEventInfo.subCategories.filter(sub => sub.categoryId === this.props.categoryId);
  };
  _getCurrentEventInfo = (catalogData) => {
    const currentEvent = (this.props.isReceptionItems) ? 'RECEPTION' : 'CEREMONY';

    return catalogData.find(itm => itm.event.name === currentEvent);
  };
  _getCurrentSubCategoriesByCategory = (subCategories, currentEventInfo) => {
    return subCategories.map(sub => currentEventInfo.subCategories.find(current => current.id === sub));
  };
  _renderSubCategories = (currentSubCategories = []) => {
    const isCeremony = this.props.isReceptionItems ? false : true;

    return currentSubCategories.map(sub => <a href={`/weddings/ideas/wishlist-catalog/?isCeremony=${isCeremony}&category=${sub.id}`} className="sub-item" key={sub.id}>{sub.name} {`(${sub.itemCount})`}</a>);
  };
  _toggleSubList = () => {
    this.setState({showSubcategories: !this.state.showSubcategories});
  };
  _getViewMoreCount = (currentSubCategories) => {
    let counter = 0;

    currentSubCategories.map(current => {
      counter += parseInt(current.itemCount, 10);
    });

    return counter;
  };

  render() {
    const { categoryName, categoryItems, initialRows } = this.props;
    const itemsToRender = (this.state.allItems.length > 0) ? this.state.allItems : categoryItems;
    const itemsPerRow = this._filterItemsByRows(itemsToRender);
    const currentCategoryItems = this._renderItems(itemsToRender, itemsPerRow);
    const isAllInspirationsItems = categoryItems[0].viewMore;
    const currentEventInfo = this._getCurrentEventInfo(this.props.inspirationEvents);
    const subCategories = this._getSubCategories(currentEventInfo);
    // const subsList = this._renderSubCategories(subCategories);
    const counter = this._getViewMoreCount(subCategories);
    const viewMoreCount = counter - currentCategoryItems.length;

    /* eslint-disable */
    return(
      <div className={`row category-container cat-id-${categoryItems[0].categoryId}`}>
        <div className="xs-12 lg-9">
          <span className="select-from">select from</span>
          <h2 className="category-name">{ categoryName }</h2>
        </div>
        {/*<div className="xs-12 lg-3 subs-dropdown">
          <label className="back-btn show" htmlFor={`listCatalog${categoryItems[0].categoryId}`}><i className="icon-arrow-right"/>view by category</label>
          <input type="checkbox" className="listCatalog" id={`listCatalog${categoryItems[0].categoryId}`}/>
          <div className="xs-11 lg-12 list-container">{subsList}</div>
        </div>*/}

        <div className="xs-12">
          <hr className="grey-divider"/>
        </div>
        <div className="xs-12">
          <div className="row">
            { currentCategoryItems }
          </div>
        </div>
        <div className={`xs-12 lg-5 xl-3
        ${(initialRows !== 'ALL' && categoryItems.length > (initialRows * 4)) || (isAllInspirationsItems && counter > (initialRows * 4))
        ? 'show'
        : (initialRows === 'ALL' && isAllInspirationsItems) ? 'show'
          : 'hide'}`}>
          <button
            className="view-more-items"
            onClick={ !this.state.isViewMoreActive ? this._viewMoreHandler : this._viewLessHandler }>
            <i className="icon-arrow-right"/>
            {`${!this.state.isViewMoreActive ? `View more Items (${viewMoreCount})` : 'View Less'}`}
          </button>
        </div>
      </div>
    );
    /* eslint-enable */
  }
}
